import { Edit, Info, Logout, Verified } from '@mui/icons-material';
import {
  Alert,
  Avatar,
  Box,
  colors,
  Container,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Slide,
  Typography,
} from '@mui/material';
import { NavLink, useSearchParams } from 'react-router-dom';
import { EditPhoneNumber } from '@app/pages/Profile/EditPhoneNumber';
import { useUserProfileController } from '@app/pages/Profile/useUserProfileController';
import { DebugPanel } from '@components';
import formatPhoneNumber from '@utils/formatPhoneNumber';
import { useApp } from '@app/App.hook';
import { FC, useEffect, useState } from 'react';
import { useAppCookies } from '@app/providers/AppCookieProvider';

interface UserProfileProps {
  onOptOut: () => void;
  onShowTermsAndConditions: () => void;
}
export const UserProfile: FC<UserProfileProps> = (props) => {
  const cookies = useAppCookies();
  const [searchParams] = useSearchParams();
  const showEdit = searchParams.get('showModal') === 'edit';
  const [showTransition, setShowTransition] = useState<boolean>(Boolean(searchParams.get('success')));
  useEffect(() => {
    if (Boolean(searchParams.get('success'))) {
      setTimeout(() => setShowTransition(true), 0);
      setTimeout(() => setShowTransition(false), 3000);
    }
  }, [searchParams]);

  const { view } = useUserProfileController();
  const { logout } = useApp();

  return (
    <Container>
      <DebugPanel displayItem={view}></DebugPanel>

      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} pt={8} pb={2}>
        <Avatar
          sx={{ height: 118, width: 118, fontSize: 56 }}
          src={cookies.profile.picture}
          alt={cookies.profile.firstName}
        ></Avatar>
        <Typography variant={'h6'}>
          {cookies.profile.firstName} {cookies.profile.lastName}
        </Typography>
        <Typography variant={'subtitle1'} color={'textSecondary'}>
          {cookies.profile.email}
        </Typography>
      </Box>
      <List>
        <ListItem sx={{ mb: 2, backgroundColor: colors.common.white, borderRadius: '6px' }}>
          <ListItemText>
            <Typography pr={2} component={'span'} fontWeight={400} fontSize={15}>
              Mobile:
            </Typography>
            <Typography component={'span'} fontWeight={400} fontSize={15}>
              +1 {formatPhoneNumber(view?.phone || '')}
            </Typography>
          </ListItemText>
          <NavLink to={'?showModal=edit'}>
            <Edit color={'primary'} />
          </NavLink>
        </ListItem>
        <ListItemButton
          onClick={logout}
          sx={{ backgroundColor: colors.common.white, color: '#EB3223', borderRadius: '6px' }}
        >
          <Logout />

          <ListItemText>
            <Typography pl={2} color={'#EB3223'}>
              Logout of App
            </Typography>
          </ListItemText>
        </ListItemButton>
      </List>
      <Box mt={2}>
        <Slide direction="right" in={showTransition} mountOnEnter unmountOnExit appear={true}>
          <Alert severity={'success'} icon={<Verified />} sx={{ fontFamily: 'Roboto', fontSize: 13 }}>
            Your new mobile number has been updated
          </Alert>
        </Slide>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: 8,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(111,167,171,0.16)',
            borderRadius: '6px',
            p: 2,
            ml: -1,
            mr: 1,
          }}
        >
          <Typography fontWeight={400} fontSize={11} component={'p'}>
            By opting into SMS text messages from We Hate Exercise, you are agreeing to receive recurring messages.
            Message frequency may vary. Message and data rates may apply. You can opt out at any time by replying STOP
            or HELP for any support
          </Typography>
          <Typography component={'p'} mt={2} fontWeight={400} fontSize={11}>
            Click Here to{' '}
            <Link href={'#'} onClick={props.onOptOut} color={colors.common.black}>
              Opt Out of Message
            </Link>
          </Typography>
        </Box>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mt={2}>
          <Link href={'#'} onClick={props.onShowTermsAndConditions} fontSize={10}>
            WHE Terms & Conditions and Privacy Policy
          </Link>
        </Box>
      </Box>
      <EditPhoneNumber open={showEdit} phoneNumber={view?.phone || ''}></EditPhoneNumber>
    </Container>
  );
};
